export default __webpack_public_path__ + "static/media/request.ed27cacd.svg";